import { Fragment } from "react"

import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router"

import {
  CHOICE_FLOWS,
  hasOnboardingProgress,
  resolveProductChoice
} from "../../../../Utils/onboarding/productChoice"
import { getSkippedStepKeys } from "../../../../Utils/onboarding/stepSequence"
import { FEATURES_STEP_PATH } from "../../../../Utils/utils"
import { OB_STEPS } from "../../../GettingStartedPage/utils/onboardingSteps"
import { createSteps } from "../../utils/constants/createSteps"
import { getAlertSubSteps } from "../../utils/helpers/getAlertSubSteps"
import { getRailState } from "../../utils/helpers/getRailState"
import { getStepState } from "../../utils/helpers/getStepState"
import OnboardingStep from "../OnboardingStep"
import OnboardingSubStep from "../OnboardingSubStep"

import "../../styles.less"

const OnboardingSideBar = ({ showSubSteps }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const userInfo = useSelector((state) => state.auth?.userInfo)
  const nextStep = userInfo?.next_step
  const enrollments = useSelector((state) => state.user.enrollments)

  const flow = CHOICE_FLOWS.ONBOARDING
  const choice = resolveProductChoice({
    flow,
    hasProgress: hasOnboardingProgress({ flow, userInfo })
  })
  const steps = createSteps(OB_STEPS, { exclude: getSkippedStepKeys(choice) })
  const currentKey = pathname.split("/")[2]
  const isAlertPage = pathname.includes("/alerts")

  const activeEnrollments = enrollments?.filter((enrollment) => enrollment.is_active)
  const isActiveRDR = activeEnrollments.some((enrollment) => enrollment.name === "RDR")

  return (
    <div className="ob-steps">
      {steps.map((s, index) => {
        const { isProcess, isSub } = getStepState(
          s.stepId,
          nextStep,
          OB_STEPS,
          showSubSteps,
          isAlertPage
        )
        const { done, active, block } = getRailState({
          steps,
          index,
          currentKey,
          progressStepId: nextStep,
          featuresDone: choice !== null
        })

        return (
          <Fragment key={s.key}>
            <OnboardingStep
              label={s.label}
              done={done}
              active={active}
              process={isProcess}
              sub={isSub}
              onClick={() => {
                if (block) return
                navigate(s.stepId == null ? FEATURES_STEP_PATH.onboarding : `/onboarding/${s.key}`)
              }}
            />

            {isSub && (
              <div className="ob-subSteps">
                {getAlertSubSteps(showSubSteps, s.subSteps)
                  .filter((ss) => ss.key !== "bin" || isActiveRDR)
                  .map((ss) => (
                    <OnboardingSubStep key={ss.key} {...ss} />
                  ))}
              </div>
            )}
          </Fragment>
        )
      })}
    </div>
  )
}

export default OnboardingSideBar
